import React, { useState } from 'react';
import { Box, MenuItem, Select, TextField, Typography } from '@mui/material';
import ExportDataasCSV from '../../components/ExportDataasCSV';
import { Heading_Text_Color } from '../../constant/constant';

const months = [
  { name: 'January', value: '01' },
  { name: 'February', value: '02' },
  { name: 'March', value: '03' },
  { name: 'April', value: '04' },
  { name: 'May', value: '05' },
  { name: 'June', value: '06' },
  { name: 'July', value: '07' },
  { name: 'August', value: '08' },
  { name: 'September', value: '09' },
  { name: 'October', value: '10' },
  { name: 'November', value: '11' },
  { name: 'December', value: '12' }
];

export default function BankDataDownload() {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState(new Date().getFullYear());

  return (
   <Box

   position="absolute"
  top="50%"
  left="50%"
  sx={{ transform: 'translate(-50%, -50%)' }}
  display="flex"
 flexDirection="column"
  alignItems="center"
  // justifyContent="flex-start"  // Move to top
  //height="100vh"
  pt={4}                       // Optional: add top padding (e.g., 32px)
  gap={3}
>
      <Typography  gutterBottom style={{ color: Heading_Text_Color, textAlign: 'center', fontSize: '1.25rem' }}>
        ⬇️ Download Unmatched Debit Data
      </Typography>

      <Box display="flex" gap={2}>
        <Select
          value={month}
           size='small'
          onChange={(e) => setMonth(e.target.value)}
          displayEmpty
          variant="outlined"
          sx={{ minWidth: 120 }}
        >
          <MenuItem value="">Select Month</MenuItem>
          {months.map((m) => (
            <MenuItem key={m.value} value={m.value}>
              {m.name}
            </MenuItem>
          ))}
        </Select>

        <TextField
          type="number"
          label="Year"
           size='small'
          value={year}
          onChange={(e) => setYear(e.target.value)}
          variant="outlined"
          sx={{ width: 100 }}
        />
      </Box>

      <ExportDataasCSV
      size='small'
        exportEndpoint="/export-detail-data"
        postData={{ month, year }}
        buttonTitle="⬇️ Download Unmatched Debit Data CSV File"
        downloadedFileName={`ExportedUnmatchedDebitFile_${months.find(m => m.value === month)?.name || 'Unknown'}_${year}.csv`}
      />
    </Box>
  );
}
